<template>
  <div class="mainDownload myScrollArea">
    <p style="font-size:20px;color:#ffffff;">我的下载</p>
    <!--搜索框-->
    <div style="position:relative;margin-top:15px;">
      <v-text-field v-model="search_keyword" @keyup.enter.native="searchInputEnter"
                    id="keywordInputArea_download" autocomplete="off" dense outlined placeholder="在已下载中搜索" dark hide-details color="#ffffff" style="width:308px;background:#2a2a2a;">
        <template v-slot:append>
          <p style="font-size:16px;font-weight:bold;color:#ffffff;cursor:pointer;" class="iconfontFamily mt-1">&#xe630;</p>
        </template>
      </v-text-field>
      <div @click="clearSearchKeyword" v-if="search_keyword!==''" style="position:absolute;top:12px;right:55px;width:16px;height:16px;cursor:pointer;">
        <p style="line-height:16px;font-size:16px;color:#c4c4c4;" class="iconfontFamily">&#xe632;</p>
      </div>
    </div>

    <!--搜索结果-->
    <div style="width:100%;min-height: calc(100% - 156px);margin-top:20px;">
      <image-item v-for="(item,index) in downloadImageList" :key="'imageItem'+index" @showImagePreview="showImagePreview" @showFolderStopDialog="showFolderStopDialog"
                  :info="item" :showPreview="item.mainId === previewImageId"
                  :style="{'margin-left':index % 2 === 1 ? '16px' : '0'}" style="margin-bottom:12px;display:inline-block;">
      </image-item>

      <p v-if="downloadImageList.length === 0" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:16px;color:#ffffff;">暂无下载内容</p>

    </div>

    <v-pagination v-if="downloadImageList.length !== 0" class="myPaginationSize22 mb-2" v-model="currPage" :length="totalPageNum" circle></v-pagination>




  </div>

</template>

<script>
import ImageItem from '../components/ImageItem';
export default {
  name: "MainDownload",
  components:{ImageItem},

  props:["previewImageId"],
  data(){
    return{

      search_keyword:"",

      //影像集列表
      downloadImageList:[],


      currPage:1,
      totalPageNum:0,


    }


  },
  watch:{
    currPage(){
      //页码变化
      this.getDownloadImageList(this.currPage)
    }

  },
  methods:{

    //获取全部下载列表
    getDownloadImageList(currPage){
      this.$axios({
        method:"get",
        url:"/authorApi/z-image-collection/getUserByList",
        params:{
          curPageNum:currPage,
          maxResultNum:10,
          keyWord:this.search_keyword
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.downloadImageList = resultData.data.list;

          this.currPage = currPage;
          this.totalPageNum = resultData.data.totalPageNum

          this.showImageMarker(this.downloadImageList)

          //可能处于预览状态
          this.$emit("quitPreviewLeftBar");
          this.$parent.map.flyTo({
            center:this.$parent.initCenter,
            zoom:this.$parent.initZoom,
            bearing:0,
            pitch:0
          })

        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },


    //回车搜索
    searchInputEnter(){
      this.getDownloadImageList(1);
      //可能处于预览状态
      this.$emit("quitPreviewLeftBar");

    },

    //清空搜索输入
    clearSearchKeyword(){
      //清空搜索框
      document.querySelector("#keywordInputArea_download").focus()
      this.search_keyword = "";
      this.searchInputEnter();
    },




    //在地图上展示影像集文件夹
    showImageMarker(imageMarkerList){
      this.$emit("showImageMarker",imageMarkerList)
    },

    //在地图上展示影像集预览
    showImagePreview(imageId){
      this.$emit("showImagePreview",imageId);
    },

    //展示影像集停用弹窗
    showFolderStopDialog(imageId){
      this.$emit("showFolderStopDialog",imageId);
    }



  },

  mounted(){

    this.getDownloadImageList(1);

  },
  destroyed() {
    this.$emit("leftBarDestroy","download")
  }
}
</script>

<style scoped>
.mainDownload{
  position:relative;
  height:100%;
  padding:15px 0 0 15px;
  overflow:auto;
}

</style>
